import { Component, ElementRef, ViewChild, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-signature-pad',
  standalone: true,
  imports: [NgIf],
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.css']
})
export class SignaturePadComponent implements AfterViewInit {
  @ViewChild('signaturePad', { static: false }) signaturePadElement!: ElementRef<HTMLCanvasElement>;
  @Output() signatureSaved = new EventEmitter<File>(); // Emits the file to parent
  
  private ctx!: CanvasRenderingContext2D;
  private isDrawing = false;
  hasDrawn = false;
  signatureError = '';

  ngAfterViewInit() {
    const canvas = this.signaturePadElement.nativeElement;
    this.ctx = canvas.getContext('2d')!;
    canvas.width = 400;
    canvas.height = 200;
    this.ctx.strokeStyle = 'black';
    this.ctx.lineWidth = 2;
    this.ctx.lineCap = 'round';

    // Mouse Events
    canvas.addEventListener('mousedown', this.startDrawing.bind(this));
    canvas.addEventListener('mousemove', this.draw.bind(this));
    canvas.addEventListener('mouseup', this.stopDrawing.bind(this));
    canvas.addEventListener('mouseleave', this.stopDrawing.bind(this));

    // Touch Events (for mobile)
    canvas.addEventListener('touchstart', this.startDrawing.bind(this));
    canvas.addEventListener('touchmove', this.draw.bind(this));
    canvas.addEventListener('touchend', this.stopDrawing.bind(this));
  }

  startDrawing(event: MouseEvent | TouchEvent) {
    this.isDrawing = true;
    this.ctx.beginPath();
    this.ctx.moveTo(this.getX(event), this.getY(event));
  }

  draw(event: MouseEvent | TouchEvent) {
    if (!this.isDrawing) return;
    event.preventDefault();
    this.hasDrawn = true;
    this.signatureError = '';
    this.ctx.lineTo(this.getX(event), this.getY(event));
    this.ctx.stroke();
  }

  stopDrawing() {
    this.isDrawing = false;
    this.ctx.closePath();
  }

  clearSignature() {
    this.ctx.clearRect(0, 0, this.signaturePadElement.nativeElement.width, this.signaturePadElement.nativeElement.height);
    this.hasDrawn = false;
    this.signatureError = '';
  }

  saveSignature() {
    if (!this.hasDrawn) {
      this.signatureError = 'Signature cannot be blank.';
      return;
    }

    this.signatureError = '';
    const dataUrl = this.signaturePadElement.nativeElement.toDataURL('image/png');
    // Convert Data URL to a File
    fetch(dataUrl)
    .then(res => res.blob())
    .then(blob => {
      const file = new File([blob], 'signature.png', { type: 'image/png' });
      
      this.signatureSaved.emit(file); // Emit file to parent
      console.log('Signature saved and emitted:', file);
    })
    .catch(error => console.error('Error converting signature to file:', error));

    console.log('Signature saved:', dataUrl);
    alert('Signature updated.');
  }

  private getX(event: MouseEvent | TouchEvent): number {
    const rect = this.signaturePadElement.nativeElement.getBoundingClientRect();
    return (event instanceof MouseEvent ? event.clientX : event.touches[0].clientX) - rect.left;
  }

  private getY(event: MouseEvent | TouchEvent): number {
    const rect = this.signaturePadElement.nativeElement.getBoundingClientRect();
    return (event instanceof MouseEvent ? event.clientY : event.touches[0].clientY) - rect.top;
  }
}
